// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insurance-card[data-v-01d29b60] {\n  background-color: #f4f2ff;\n}\n.insurance-card-dark[data-v-01d29b60] {\n  background-color: #e7e8e9;\n}\n.insurance-badge[data-v-01d29b60] {\n  background-color: #d1d2d4;\n  color: #000000;\n}\n.insurance-info[data-v-01d29b60] {\n  font-size: 1.1rem;\n}", ""]);
// Exports
module.exports = exports;
